import React from 'react';
import PropTypes from 'prop-types';

import RatePresenter from '../../../../../../../../presenters/RatePresenter';

import RateCell from './components/RateCell';

const RateTable = (props) => {
  const { rates } = props;

  return (
    <table className="rates-table">
      <thead>
        <tr>
          <th>Periods</th>
          <th>Rate</th>
          <th>State</th>
        </tr>
      </thead>
      <tbody>
        {rates.map((rate, index) => (
          <RateCell key={index} rate={rate} />
        ))}
      </tbody>
    </table>
  );
};

export default RateTable;

RateTable.propTypes = {
  rates: PropTypes.arrayOf(RatePresenter.shape()).isRequired,
};
